// The dark code console's palette.
//
// A dark surface inside a light-theme app, so no semantic token resolves to
// these colours and every one of them is literal. They live here rather than in
// either screen because two now draw the same console — the landing hero's cURL
// walkthrough (routes/landing/CodeConsole) and the credentials screen's Basic
// auth example (routes/credentials/CurlConsole) — and a console that drifted
// half a shade between the two would read as a rendering bug rather than a
// choice.

export const CONSOLE = {
  surface: '#1C1917',
  line: 'rgba(255, 255, 255, 0.07)',
  text: '#D6D3D1',
  textBright: '#E7E5E4',
  textStrong: '#FAFAF9',
  subdued: '#A8A29E',
  muted: '#78716C',
  dim: '#57534E',
  /** Strings in a snippet, and the landing feed's LIVE marker. */
  accent: '#4EE7A6',
  /** The landing console's pulsing "listening" dot. */
  live: '#00E28F',
} as const
